import { Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { ShiveDialogService } from '../../../../../../core/services/controls/shive-dialog.service';
import { UserOperation } from '../../../../../../core/enums/user-operation';
import { CostRateEntryModel } from '../../../../../../core/models/user/cost-rate-entry.model';
import { FormControlNameRecord } from '../../../../../../shared/data-types/form-types';
import { CostRateEntryService } from '../../manage-project/project-calculation-form/services/cost-rate-entry.service';
import { UserModel } from '../../../../../../core/models/user/user.model';

@Component({
  selector: 'app-cost-rate-history-dialog',
  standalone: false,
  templateUrl: './cost-rate-history-dialog.component.html',
  styleUrl: './cost-rate-history-dialog.component.scss',
})
export class CostRateHistoryDialogComponent implements OnInit {
  @Input() costRateHistory: CostRateEntryModel[];
  @Input() user: UserModel;
  public updateEnabled = false;
  public costRateHistoryForm: FormGroup;
  public readonly formControlNames: FormControlNameRecord = {
    NewCostRate: 'newCostRate',
    ApplyCostRateTo: 'applyCostRateTo',
    DateFrom: 'dateFrom',
  };
  public readonly faPenToSquare = faPenToSquare;
  // DI
  private readonly formBuilder = inject(FormBuilder);
  private readonly shiveDialogService = inject(ShiveDialogService);
  private readonly costRateEntryService = inject(CostRateEntryService);

  ngOnInit(): void {
    this.initForm();
  }

  public close(): void {
    this.shiveDialogService.close(UserOperation.Cancel);
  }

  public submit(): void {
    const costRateValue =
      +this.costRateHistoryForm.controls[this.formControlNames.NewCostRate].value;

    if (this.costRateHistoryForm.controls[this.formControlNames.ApplyCostRateTo].value === 'all') {
      this.costRateHistory = [
        this.costRateEntryService.createCostEntry(
          costRateValue,
          this.user.created_date,
          this.user.id,
        ),
      ];
    } else {
      // 'custom'
      const startingFrom = this.costRateHistoryForm.controls.dateFrom.value;
      const newCostRateEntry: CostRateEntryModel = this.costRateEntryService.createCostEntry(
        costRateValue,
        startingFrom,
        this.user.id,
      );

      this.costRateHistory = this.costRateEntryService.alignCostRateEntriesByDateFrom(
        newCostRateEntry,
        this.costRateHistory,
      );
    }
    this.shiveDialogService.close(this.costRateHistory);
  }

  public buttonChanged(): void {
    if (
      this.costRateHistoryForm.controls[this.formControlNames.ApplyCostRateTo].value === 'custom'
    ) {
      this.costRateHistoryForm.controls[this.formControlNames.DateFrom].disable();
    } else {
      this.costRateHistoryForm.controls[this.formControlNames.DateFrom].enable();
    }
  }

  public inputValueChanged(newValue: unknown): void {
    this.updateEnabled = newValue !== null;
  }

  private initForm(): void {
    this.costRateHistoryForm = this.formBuilder.group({
      [this.formControlNames.NewCostRate]: [],
      [this.formControlNames.ApplyCostRateTo]: ['all'],
      [this.formControlNames.DateFrom]: [{ value: new Date(), disabled: true }],
    });
  }
}
